var irreducible = require('./irreducible');

module.exports = irreducible('Date', function (x) { return x instanceof Date; });



/*****************
 ** WEBPACK FOOTER
 ** ./~/tcomb/lib/Date.js
 ** module id = 492
 ** module chunks = 1
 **/